import type { ReactNode } from "react";

import { Text } from "@alpacahq/ui/old";

import {
  FILE_ACCEPTED_TYPES,
  FILE_MAX_SIZE,
  FILE_SIZE_LABEL,
  FileDropzone,
} from "~/v2/components/fileUpload";
import type { UseUploadOwnerDocumentReturn } from "./useUploadOwnerDocument";

export interface OwnerDocumentFieldProps {
  label: string;
  description: ReactNode;
  name: string;
  document: UseUploadOwnerDocumentReturn;
}

// Presentational field for a single deferred owner document. Pairs with
// useUploadOwnerDocument and reuses the shared FileDropzone building block.
export const OwnerDocumentField = ({
  label,
  description,
  name,
  document,
}: OwnerDocumentFieldProps) => {
  const { file, error, onUpload, onError, onRemove } = document;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Text className="font-semibold">{label}</Text>
        {error && (
          <Text className="truncate text-rose-500 text-xs">{error}</Text>
        )}
      </div>

      <Text>{description}</Text>
      <FileDropzone
        name={name}
        label={label}
        file={file}
        placeholder={name}
        onUpload={onUpload}
        onError={onError}
        onRemove={onRemove}
        isRequired
        maxSize={FILE_MAX_SIZE}
        maxSizeLabel={FILE_SIZE_LABEL}
        accept={FILE_ACCEPTED_TYPES}
        displayType="file"
      />
    </div>
  );
};
